import { render, staticRenderFns } from "./SiteIntroduction.vue?vue&type=template&id=fda717f2&scoped=true"
import script from "./SiteIntroduction.vue?vue&type=script&lang=js"
export * from "./SiteIntroduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda717f2",
  null
  
)

export default component.exports